export const utilsDeptLabels = {
  key: 'utilsDeptLabels',
  name: 'Utils Dept-Labels',
  siteIdentifier: 'global',

  formerlyTwitter: 'X (formerly Twitter)',
};
